__turbopack_context__.v({
  "marquee": "marquee-module__UBIRma__marquee",
  "marqueeContainer": "marquee-module__UBIRma__marqueeContainer",
  "marqueeScroll": "marquee-module__UBIRma__marqueeScroll",
  "marqueeWrapper": "marquee-module__UBIRma__marqueeWrapper",
  "onMobile": "marquee-module__UBIRma__onMobile",
});
